import React, { useEffect, useRef, useState } from "react";
import { Button, Popover, Space, Row, Table, Popconfirm } from "antd";
import "./ListPatient.scss";
import { allColumns, fields } from "./config";
import {
  CalendarSVG,
  CalendarSelectedSVG,
  ExcelSVG,
  ListIconSVG,
  RecycleSVG,
} from "assets";
import {
  formatDateToString,
  getTableOptions,
  saveTableOptions,
} from "helper/common";
import {
  ListActionButton,
  ExpandSearch,
  ColumnPopoverDisplay,
  ModalCustom,
} from "components/common";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setActiveKey, setIdPhieuKham } from "redux/reducer/common";
import { tabKeys } from "types/enums";
import Notification from "components/common/notification/notification";
import diagnose from "api/diagnose";
import {
  setIdDiagnose,
  setIsCallResultDiagnose,
  setTGCDDiagnose,
} from "redux/reducer/diagnose";
import dayjs from "dayjs";
import { ColumnsEdit } from "types/models/column-table-edit";
import DiagnoseModal from "components/common/PrintReceipt/DiagnoseModal/DiagnoseModal";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import CheckNullApi from "components/common/CheckNullApi/CheckNullApi";

const savedTableOption = getTableOptions(
  tabKeys.DIAGNOSE.DIAGNOSE_TABLE,
  localStorage.getItem("username")
);
const defaultColumns = savedTableOption
  ? allColumns.map((cl) => {
      if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
        return {
          ...cl,
          show: true,
        };
      } else
        return {
          ...cl,
          show: false,
        };
    })
  : allColumns;

const ListPatient: React.FC = () => {
  const dispatch = useAppDispatch();
  const expandRef = useRef<any>();
  const printRef = useRef<any>();

  const [params, setParams] = useState<any>({
    page: 1,
    limit: 50,
    ngayTaoDen: dayjs(),
    ngayTaoTu: dayjs(),
  });

  const [columns, setColumns] = useState<ColumnsEdit>(
    defaultColumns.filter((e) => e.show == true)
  );

  const [selectedBtn, setSelectedBtn] = useState<number | null>(1);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState();

  const activeTab = useAppSelector((e) => e.common.activeTab);
  useEffect(() => {
    getList();
  }, [params, activeTab]);

  const postStatusDiagnoseForm = async (id, trangThai) => {
    setLoading(true);
    try {
      const params = {
        id: id,
        trangThai: trangThai,
      };
      const res = await diagnose.updateStatusDiagnose(params);

      setLoading(false);
      let message = "";
      if (trangThai == 1) {
        message = "Đã cập nhật phiếu thành trạng thái chờ thực hiện";
      }
      if (trangThai == 3) {
        message = "Đã cập nhật phiếu thành trạng thái hoàn thành";
      }
      if (trangThai == 6) {
        message = "Đã cập nhật phiếu thành trạng thái hủy thực hiện";
      }
      if (trangThai == 7) {
        message = "Đã xóa thông tin phiếu";
      }
      getList();

      Notification("success", message);
    } catch (error) {
      setLoading(false);

      Notification("error", "Đã có lỗi xảy ra");
    }
  };

  const handleEdit = (record) => {
    dispatch(setActiveKey(tabKeys.DIAGNOSE.DETAIL_INFO));
    dispatch(setIdDiagnose(record.id));
    dispatch(setTGCDDiagnose(record.thoiGianChiDinh));
    dispatch(setIdPhieuKham(record.idPhieuKham));
  };

  const handlePrint = (id: number | string) => {
    dispatch(setIdDiagnose(id));
    dispatch(setIsCallResultDiagnose(true));
    printRef.current.openModal();
  };
  const handleDelete = async (id) => {
    const newData = await data?.filter((item) => item.id !== id);

    setData(newData);
  };

  allColumns.find((e) => e.dataIndex == "action").render = (
    value,
    _record: { trangThai: number; id: number | string },
    index
  ) => {
    return (
      <ListActionButton
        editFunction={() => handleEdit(_record)}
        printFunction={() => handlePrint(_record.id)}
      >
        <Popconfirm
          className="danger-confirm"
          title={`Đồng ý ${
            _record["trangThai"] == 3 ? "xóa thông tin" : "hủy khám"
          }`}
          onConfirm={() => {
            if (_record?.trangThai == 1) {
              handleDelete(_record.id);
              postStatusDiagnoseForm(_record.id, 7);
            } else {
              postStatusDiagnoseForm(_record.id, 6);
            }
          }}
        >
          <Button type="text" icon={<RecycleSVG />} />
        </Popconfirm>
      </ListActionButton>
    );
  };

  const onToday = (key: number) => {
    setParams({ ...params, ngayTaoDen: dayjs(), ngayTaoTu: dayjs() });

    setSelectedBtn(key);
  };

  const onYesterday = (key: number) => {
    setParams({
      ...params,
      ngayTaoDen: dayjs().subtract(1, "day"),
      ngayTaoTu: dayjs().subtract(1, "day"),
    });

    setSelectedBtn(key);
  };

  const onChangePagination = (page, pageSize) => {
    setParams({ ...params, page: page, limit: pageSize });
  };

  const setShowColumns = (showColumns) => {
    saveTableOptions(
      tabKeys.DIAGNOSE.DIAGNOSE_TABLE,
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };

  allColumns.find((e) => e.dataIndex == "stt").render = (
    text,
    record,
    index
  ) => {
    const rowNumber = (params.page - 1) * params.limit + index + 1;
    return rowNumber;
  };

  const onClickSearchButton = () => {
    var searchFields = expandRef.current?.getData();
    setParams({
      ...params,
      ...searchFields,
      page: 1,
    });
  };

  const getList = async () => {
    setLoading(true);
    try {
      const res = await diagnose.getLitDiagnose(formatParams());
      const newData = res.data.map((item) => {
        return { ...item, key: item.id };
      });
      setData(newData);
      setTotal(res.total);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi tải dữ liệu");
    }
  };

  const formatParams = () => {
    return {
      ...params,
      ngaySinh: formatDateToString(params.ngaySinh),
      ngayTaoTu: formatDateToString(params.ngayTaoTu),
      ngayTaoDen: formatDateToString(params.ngayTaoDen),
    };
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedRowKeys([selectedRowKeys[selectedRowKeys.length - 1]]);
      if (selectedRows.length == 0) {
        dispatch(setIdDiagnose(null));
      } else {
        dispatch(setIdDiagnose(selectedRows[selectedRows.length - 1].id));
        dispatch(
          setIdPhieuKham(selectedRows[selectedRows.length - 1].idPhieuKham)
        );
        dispatch(
          setTGCDDiagnose(selectedRows[selectedRows.length - 1].thoiGianChiDinh)
        );
      }
    },
    hideSelectAll: true,
    selections: [Table.SELECTION_NONE],
  };

  const label = [
    {
      key: 1,
      value: "Hôm nay",
      onclick: (e) => onToday(e),
    },
    {
      key: 2,
      value: "Hôm qua",
      onclick: (e) => onYesterday(e),
    },
  ];

  const onKeyDown = (e) => {
    if (e.key == "Enter") {
      onClickSearchButton();
    }
  };
  //check xem có đủ api chưa?
  useEffect(() => {
    CheckNullApi();
  }, []);
  return (
    <div className="list-patient-nurse" onKeyDown={onKeyDown} tabIndex={0}>
      <div className="container">
        <Space direction="vertical" style={{ width: "100%" }}>
          <ExpandSearch
            ref={expandRef}
            onClickSearch={onClickSearchButton}
            fields={fields}
            onReset={() => {
              onClickSearchButton();
            }}
            initialValues={params}
          ></ExpandSearch>
        </Space>
      </div>

      <div className="container">
        <Space direction="vertical" style={{ width: "100%" }}>
          <Row justify={"end"} gutter={[16, 16]}>
            <Space>
              {label.map((item) => (
                <Button
                  key={item.key}
                  onClick={() => {
                    item.onclick(item.key);
                  }}
                  className={
                    item.key === selectedBtn ? "btn-sub" : "custom-btn"
                  }
                  icon={
                    item.key === selectedBtn ? (
                      <CalendarSelectedSVG />
                    ) : (
                      <CalendarSVG />
                    )
                  }
                >
                  {item.value}
                </Button>
              ))}

              <Popover
                trigger="click"
                placement="topLeft"
                content={
                  <ColumnPopoverDisplay
                    setShowColumns={setShowColumns}
                    columns={defaultColumns}
                  ></ColumnPopoverDisplay>
                }
              >
                <Button className="btn-sub" icon={<ListIconSVG />}>
                  Cột hiển thị
                </Button>
              </Popover>
              {/* <Button icon={<ExcelSVG />} className="btn-svg">
                Xuất báo cáo
              </Button> */}
            </Space>
          </Row>

          <CustomResizableTable
            setShowColumns={setShowColumns}
            loading={loading}
            columns={columns}
            dataSource={data}
            className="custom-resize-table-scroll"
            // scroll={{ y: 500}}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              total: total,
              pageSize: params.limit,
              current: params.page,
              onChange: onChangePagination,
            }}
            onRow={(record) => ({
              onDoubleClick: () => handleEdit(record),
            })}
            bordered
            rowSelection={{
              ...rowSelection,
            }}
          />
        </Space>
      </div>
      <div onBlur={() => dispatch(setIsCallResultDiagnose(false))}>
        <ModalCustom
          wrapClassName="modal-print-form"
          ref={printRef}
          centered
          width={900}
        >
          <DiagnoseModal />
        </ModalCustom>
      </div>
    </div>
  );
};
export default ListPatient;
